import { render, staticRenderFns } from "./LeaveSearch.vue?vue&type=template&id=15e31e50"
import script from "./LeaveSearch.vue?vue&type=script&lang=js"
export * from "./LeaveSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports